module.exports = __webpack_public_path__ + "img/logo.db057026.png";